import { doc, getDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';


export async function getContestData() {
    const docRef = doc(db, 'concurs', 'dateConcurs');
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        return docSnap.data();
    } else {
        throw new Error("Terms document does not exist");
    }
}